module.exports = __webpack_public_path__ + "img/mpg.f9dd1171.svg";